
import React, { ChangeEvent, useState } from 'react'
import { CardLimit, CardLimits } from 'api/Models'
import { Modal, ModalProps } from './Modal'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
// import { Input } from 'react-select/animated'
// import { ModalBodyProps } from 'react-bootstrap/ModalBody'

// interface CardLimitFormGroupProps {
// 	label: string
// 	cardLimit: CardLimit
// 	onChange: (cardLimits: CardLimits) => void
// }

interface SingleProps {
    limit: CardLimit
    title: string
    onInput: (limit: CardLimit) => void
}

function Single(props: SingleProps) {
    const cardLimit = props.limit

    const float = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target?.value) {
            return parseFloat(e.target.value)
        }

        return 0
    }

    const int = (e: ChangeEvent<HTMLInputElement>) => {
        console.log('this is int shit')
        if (e.target?.value) {
            const intValue = parseInt(e.target.value)
            e.target.value = intValue.toString()
            return intValue
        }

        return 0
    }

    return (
        <Form className="">
            <h2>{props.title}</h2>
            <hr></hr>
            <Card border={'light'}>
                <h3>Cash</h3>
                <Row className={'form-group'}>
                    <Col xs={6}>
                        <label>Amount</label>
                        <input
                            type="number"
                            value={cardLimit.cashAmount}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, cashAmount: float(e) })}
                        />
                    </Col>
                    <Col xs={6}>
                        <label>Use counter</label>
                        <input
                            type="number"
                            value={cardLimit.atmUseCounter}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, atmUseCounter: int(e) })}
                        />
                    </Col>
                </Row>

                <h3>POS</h3>
                <Row className={'form-group'}>
                    <Col xs={6}>
                        <label>Amount</label>
                        <input
                            type="number"
                            value={cardLimit.nonCacheAmount}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, nonCacheAmount: float(e) })}
                        />
                    </Col>
                    <Col xs={6}>
                        <label>Use counter</label>
                        <input
                            type="number"
                            value={cardLimit.posUseCounter}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, posUseCounter: int(e) })}
                        />
                    </Col>
                </Row>

                <h3>Internet</h3>
                <Row className={'form-group'}>
                    <Col xs={6}>
                        <label>Amount</label>
                        <input
                            type="number"
                            value={cardLimit.internetAmount}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, internetAmount: float(e) })}
                        />
                    </Col>
                    <Col xs={6}>
                        <label>Use counter</label>
                        <input
                            type="number"
                            value={cardLimit.internetUseCounter}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, internetUseCounter: int(e) })}
                        />
                    </Col>
                </Row>

                <h3>MOTO</h3>
                <Row className={'form-group'}>
                    <Col xs={6}>
                        <label>Amount</label>
                        <input
                            type="number"
                            value={cardLimit.motoAmount}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, motoAmount: float(e) })}
                        />
                    </Col>
                    <Col xs={6}>
                        <label>Use counter</label>
                        <input
                            type="number"
                            value={cardLimit.motoUseCounter}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, motoUseCounter: int(e) })}
                        />
                    </Col>
                </Row>

                <h3>Total amount</h3>
                <Row className={'form-group'}>
                    <Col>
                        <input
                            type="number"
                            value={cardLimit.totalAmount}
                            className="form-control"
                            onChange={(e) => props.onInput({ ...props.limit, totalAmount: float(e) })}
                        />
                    </Col>
                </Row>
            </Card>
        </Form>
    )
}

interface TextEditFormProps {
    initial: string
    placeholder?: string
    onCancel: () => void
    onSubmit: (newValue: string) => void
}

function TextEditForm(props: TextEditFormProps) {
    const [cardLimits, setCardLimits] = useState<string>(props.initial)

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        props.onSubmit(cardLimits)
    }

    return (
        <form onSubmit={onSubmit}>
            <div className="form-block">
                <input className='form-control' 
                type="text" value={cardLimits} onChange={(e: any) => setCardLimits(e.target.value)} placeholder={props.placeholder} />

                <Row className={'form-group'} style={{ marginTop: '10px' }}>
                    <Col xs={6}>
                        <Button variant={"info"} onClick={() => props.onCancel()}>Cancel</Button>
                    </Col>
                    <Col xs={6}>
                        <Button variant={"primary"} onClick={() => props.onSubmit(cardLimits)}>Submit</Button>
                    </Col>
                </Row>
            </div>
        </form>
    )
}

//export default CardLimitsForm
function TextEditModalBody(props: ModalProps<string>, original: string, placeholder?: string) {

    const onApply = (newValue: string) => {
        if (props.onApply) {
            props.onApply(newValue)
        }
    }

    const onCancel = () => {
        if (props.onCloseModal) {
            props.onCloseModal()
        }
    }

    return (
        <>
            <h2>{props.title}</h2>
            <TextEditForm initial={original} onSubmit={onApply} onCancel={onCancel} placeholder={placeholder} />
        </>
    )
}

interface TextEditModalProps extends ModalProps<string> {
    original: string
    placeholder?: string
    title?: string
}

function TextEditModal(props: TextEditModalProps) {
    //const [cardLimits, setCardLimits] = useState<CardLimits>(props.initial);
    return (
        <Modal
            modalBody={(p) => TextEditModalBody(p, props.original, props.placeholder)}
            {...props}
        />
    )
}

export default TextEditModal
